import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../models/user';

export interface DeviceState {
    user?: User,
    authAfterUnothirizedAccess: boolean;
    loadedRoutes: string[];
    currFranchise: ModelId;
    config: any;
    loading: boolean;
    explicitFranchise: boolean;
    insight?: string;
}

const initialState: DeviceState = {
    loadedRoutes: [],
    authAfterUnothirizedAccess: false,
    currFranchise: 1,
    config: {},
    loading: false,
    explicitFranchise: false
};

export const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        setUser(state, action: PayloadAction<User>) {
            state.user = action.payload;
            state.config = action.payload.config;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setConfig(state, action: PayloadAction<any>) {
            state.config = action.payload;
        },
        setFranchise(state, action: PayloadAction<ModelId>) {
            state.currFranchise = action.payload;
        },
        setExplicitFranchise(state, action: PayloadAction<boolean>) {
            state.explicitFranchise = action.payload;
        },
        onRoute(state, action: PayloadAction<string>) {
            if (state.loadedRoutes.indexOf(action.payload) === -1) {
                state.loadedRoutes.push(action.payload);
            }
        },
        setAuthAfterUnothirizedAccess(state, action: PayloadAction<boolean>) {
            state.authAfterUnothirizedAccess = action.payload;
        },
        clearLoadedRoutes(state) {
            state.loadedRoutes = [];
        },
        setInsight(state, action: PayloadAction<string | undefined>) {
            state.insight = action.payload;
        }
    }
});
